import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FiltrocanvasComponent } from '../filtrocanvas/filtrocanvas.component';
import Swal from 'sweetalert2';

// El widget PivotView (Syncfusion) y su locale viven en PivotComponent (UiHeavyModule,
// lazy). Aqui solo se arma el dataSourceSettings y se pasa via <app-lazy-heavy type="pivot">.
// Por eso este componente ya NO importa @syncfusion/ej2-angular-pivotview: queda liviano y
// puede seguir siendo eager en UiModule (necesita <app-filtrocampo> -> <app-advancedtable>).

@Component({
  selector: 'app-flexmonster',
  templateUrl: './flexmonster.component.html',
  styleUrls: ['./flexmonster.component.scss']
})
export class FlexmonsterComponent implements OnInit {

  pantallas = [];
  isFlex = false;
  order_mostrar: boolean = false;
  filtro = { CNT05COD: "" };
  SYS02CON = '';
  SYS02DES = '';
  accionFiltrar = 0;
  FILTROS_OPCIONALES = {};
  licencia = "";
  filtrosCampo = [];

  // Tipados como any para no acoplar este componente a la libreria PivotView (lazy).
  public dataSourceSettings?: any;
  public width?: string;
  displayOption: any;
  toolbarOptions: any;

  // Objeto de inputs para <app-lazy-heavy type="pivot">. Se reasigna SOLO al abrir un
  // pivot (no en cada ciclo de CD) para no reiniciar el estado del PivotView en cada click.
  pivotInputs: any = {};

  currentPage: number;
  offcanvasRef: any;
  respFiltros = [
    {
      "FiltrosExpuestos": [
        {
          "type": "textbox",
          "label": "SYS02CON",
          "title": "Consecutivo reporte",
          "value": "",
          "validators": {
            "required": false,
            "msg_validacion": ""
          }
        },
        {
          "type": "textbox",
          "label": "SYS02DES",
          "title": "Descripción",
          "value": "",
          "validators": {
            "required": false,
            "msg_validacion": ""
          }
        },
        {
          "type": "textbox",
          "label": "A02COD",
          "title": "Tabla",
          "value": "",
          "validators": {
            "required": false,
            "msg_validacion": ""
          }
        }
      ],
      "FiltrosAvanzado": [],
    }
  ]
  formFiltros = null;


  constructor(private dataService: SharedService, private offcanvasService: NgbOffcanvas) { }

  ngOnInit(): void {
    this.filtro.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    this.cargarLista();

    this.displayOption = { view: 'Both' };
    this.toolbarOptions = ['Grid', 'Chart', 'Export', 'SubTotal', 'GrandTotal', 'ConditionalFormatting', 'NumberFormatting', 'FieldList'];
  }

  cargarLista() {
    let jsonFiltro;
    if (this.formFiltros != null) {
      jsonFiltro = { ...this.filtro, ...this.formFiltros };
    } else {
      jsonFiltro = { ...this.filtro };
    }
    this.dataService.ConsultarWS("api/ws/flexmonster/ListarPantallas", JSON.stringify(jsonFiltro)).subscribe(datos => {
      this.pantallas = datos.pantallas;
      this.licencia = datos.key;
    });
  }

  abrirFlexFiltros(filtros) {
    this.FILTROS_OPCIONALES = filtros;
    this.abrirFlex(this.SYS02CON);
  }

  abrirFlex(SYS02CON) {
    let datosTabla = [];
    let columnas = [];
    this.dataService.ConsultarWS("api/mantenimientos/ListarGenerico/" + SYS02CON, JSON.stringify({ FILTROS_OPCIONALES: [this.FILTROS_OPCIONALES], FILTROS_OBLIGATORIOS: [] }))
    .subscribe(datos => {
      datosTabla = datos.DataTable;
      this.filtrosCampo = datos.Filtros;
      this.SYS02DES = datos.SYS02DES;

      for (let i = 0; i < datos.Estructura.length; i++) {
        if (datos.Estructura[i].A03VIS === "S") {
          columnas.push(datos.Estructura[i]);
        }
      }

      let json: Object[] = [];
      for (const fila of datosTabla) {
        let filaJson = new Object();
        for (const col of columnas) {
          if (col.A03TIP == "decimal" || col.A03TIP == "int") {
            filaJson[col.A03COD] = fila[col.A03COD].replaceAll(',', '');
          } else {
            filaJson[col.A03COD] = fila[col.A03COD];
          }
        }
        json.push(filaJson);
      }

      let mapping = [];
      let filas = [];
      let cols = [];
      let measures = [];
      let mappingFields = [];
      for (const col of columnas) {

        mappingFields.push({ name: col.A03COD, caption: col.A03DES});

        if (col.A03TIP == "decimal" || col.A03TIP == "int") {
          mapping.push({ name: col.A03COD, caption: col.A03DES, format: 'N' });
        } 

        if (col.SYS03POS == 'C') {
          cols.push({ name: col.A03COD, caption: col.A03DES });
        }
        if (col.SYS03POS == 'F') {
          filas.push({ name: col.A03COD, caption: col.A03DES });
        }
        if (col.SYS03OPE != '') {
          measures.push({ name: col.A03COD, caption: col.A03DES, type: col.SYS03OPE });
        }
      }

      this.dataSourceSettings = {
        dataSource: json as any[],
        expandAll: false,
        enableSorting: true,
        columns: cols,
        rows: filas,
        values: measures,
        formatSettings: mapping,
        fieldMapping : mappingFields,
        filters: []
      };
      
      this.width = "100%";      
      // Snapshot estable de inputs para el wrapper lazy del PivotView.
      this.pivotInputs = {
        dataSourceSettings: this.dataSourceSettings,
        displayOption: this.displayOption,
        toolbarOptions: this.toolbarOptions,
        width: this.width
      };
      this.isFlex = true;
      this.SYS02CON = SYS02CON;
    },
      error => {
        Swal.fire({
          html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-4">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            '</div>' +
            ' <div class="col-8">' +
            '<h3>Error</h3><br>' +
            ' <p>' + error + '</p>' +
            ' </div> ',
        })
      }
    );
  }

  atras() {
    this.isFlex = false;
    this.SYS02CON = '';
    this.FILTROS_OPCIONALES = {};
    this.filtrosCampo = [];
  }

  filtrar() {
    this.accionFiltrar++;
  }

  limpiar() {
    this.abrirFlexFiltros({});
  }

  pageChange(event) {
    this.currentPage = event;
  }

  ordendes(val) {
    this.pantallas.sort((a, b) => b[val] - a[val]);
    this.pantallas.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return -1;
        }
        return 0;
      }
    });
    this.order_mostrar = true;
  }

  ordenasc(val) {
    this.pantallas.sort((a, b) => a[val] - b[val]);
    this.pantallas.sort((a, b) => {
      if (isNaN(Number(a[val])) && isNaN(Number(b[val]))) {
        if (a[val].toLowerCase() < b[val].toLowerCase()) {
          return 1;
        }
        if (a[val].toLowerCase() > b[val].toLowerCase()) {
          return -1;
        }
        return 0;

      }
    })
    this.order_mostrar = false;
  }

  open() {
    this.offcanvasRef = this.offcanvasService.open(FiltrocanvasComponent, { backdrop: true, position: 'end', scroll: true, backdropClass: 'bg-transparent', panelClass: 'scroll-canvas' });
    this.offcanvasRef.componentInstance.form_template = this.respFiltros;
    this.offcanvasRef.componentInstance.formFiltros = this.formFiltros;
    this.offcanvasRef.result.then((result) => {
      this.formFiltros = result;
      this.cargarLista();
    }).catch(() => {

    });
  }
}
